import * as React from "react";
import PropTypes from "prop-types";
import camelCase from "lodash-es/camelCase";

const RightScreen = ({
  gradient,
  fillOnSurface,
  fillSurface,
  bottomBarFill,
  primary,
  name,
}) => {
  const gradientName = `rightScreenGradient-${camelCase(name)}`;
  return (
    <svg viewBox="0 0 268 390" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id={gradientName} x1="0" y1="0" x2="1" y2="1">
          {gradient.map((color, i) => (
            <stop
              key={`right-screen-${i}`}
              stopColor={color}
              offset={i / Math.max(1, gradient.length - 1)}
            ></stop>
          ))}
        </linearGradient>
      </defs>
      <path
        d="M0 4C0 1.79086 1.79086 0 4 0H264C266.209 0 268 1.79086 268 4V386C268 388.209 266.209 390 264 390H4C1.79086 390 0 388.209 0 386V4Z"
        fill={fillOnSurface}
      />
      <rect width="268" height="60" fill={`url(#${gradientName})`} />
      <path
        d="M20.6667 78H11.3333C10.5933 78 10 78.6 10 79.3333V88.6667C10 89.4 10.5933 90 11.3333 90H20.6667C21.4067 90 22 89.4 22 88.6667V79.3333C22 78.6 21.4067 78 20.6667 78ZM14.6667 87.3333L11.3333 84L12.2733 83.06L14.6667 85.4467L19.7267 80.3867L20.6667 81.3333L14.6667 87.3333Z"
        fill={primary}
      />
      <rect x="28" y="76" width="53.3333" height="16" fill={fillSurface} />
      <path
        d="M110.001 78H100.667C99.9273 78 99.334 78.6 99.334 79.3333V88.6667C99.334 89.4 99.9273 90 100.667 90H110.001C110.741 90 111.334 89.4 111.334 88.6667V79.3333C111.334 78.6 110.741 78 110.001 78ZM104.001 87.3333L100.667 84L101.607 83.06L104.001 85.4467L109.061 80.3867L110.001 81.3333L104.001 87.3333Z"
        fill={primary}
      />
      <rect x="117.334" y="76" width="53.3333" height="16" fill={fillSurface} />
      <path
        d="M199.333 78H189.999C189.259 78 188.666 78.6 188.666 79.3333V88.6667C188.666 89.4 189.259 90 189.999 90H199.333C200.073 90 200.666 89.4 200.666 88.6667V79.3333C200.666 78.6 200.073 78 199.333 78ZM193.333 87.3333L189.999 84L190.939 83.06L193.333 85.4467L198.393 80.3867L199.333 81.3333L193.333 87.3333Z"
        fill={primary}
      />
      <rect x="206.666" y="76" width="53.3333" height="16" fill={fillSurface} />
      <rect
        width="268"
        height="24"
        transform="translate(0 108)"
        fill={fillSurface}
      />
      <rect x="74" y="112" width="120" height="16" fill={fillOnSurface} />
      <rect
        width="268"
        height="24"
        transform="translate(0 148)"
        fill={fillOnSurface}
      />
      <rect x="8" y="152" width="120" height="16" fill={fillSurface} />
      <rect
        width="268"
        height="48"
        transform="translate(0 180)"
        fill={fillOnSurface}
      />
      <rect x="8" y="184" width="40" height="40" fill={fillSurface} />
      <rect x="64" y="184" width="120" height="16" fill={fillSurface} />
      <rect x="64" y="204" width="73" height="16" fill={fillSurface} />
      <rect x="200" y="184" width="28" height="12" fill={fillSurface} />
      <rect x="232" y="184" width="28" height="12" fill={fillSurface} />
      <rect
        width="268"
        height="48"
        transform="translate(0 236)"
        fill={fillOnSurface}
      />
      <rect x="8" y="240" width="40" height="40" fill={fillSurface} />
      <rect x="64" y="240" width="120" height="16" fill={fillSurface} />
      <rect x="64" y="260" width="73" height="16" fill={fillSurface} />
      <rect x="200" y="240" width="28" height="12" fill={fillSurface} />
      <rect x="232" y="240" width="28" height="12" fill={fillSurface} />
      <rect
        width="268"
        height="48"
        transform="translate(0 292)"
        fill={fillOnSurface}
      />
      <rect x="8" y="296" width="40" height="40" fill={fillSurface} />
      <rect x="64" y="296" width="120" height="16" fill={fillSurface} />
      <rect x="64" y="316" width="73" height="16" fill={fillSurface} />
      <rect x="200" y="296" width="28" height="12" fill={fillSurface} />
      <rect x="232" y="296" width="28" height="12" fill={fillSurface} />
      <rect
        width="268"
        height="44"
        transform="translate(0 346)"
        fill={bottomBarFill}
      />
      <rect x="15.5996" y="354" width="16" height="16" fill={fillOnSurface} />
      <rect x="11.5996" y="374" width="24" height="8" fill={fillOnSurface} />
      <rect x="70.7988" y="354" width="16" height="16" fill={fillOnSurface} />
      <rect x="66.7988" y="374" width="24" height="8" fill={fillOnSurface} />
      <rect x="126" y="354" width="16" height="16" fill={fillOnSurface} />
      <rect x="122" y="374" width="24" height="8" fill={fillOnSurface} />
      <rect x="181.199" y="354" width="16" height="16" fill={fillOnSurface} />
      <rect x="177.199" y="374" width="24" height="8" fill={fillOnSurface} />
      <rect x="236.4" y="354" width="16" height="16" fill={fillOnSurface} />
      <rect x="232.4" y="374" width="24" height="8" fill={fillOnSurface} />
    </svg>
  );
};

RightScreen.propTypes = {
  gradient: PropTypes.arrayOf(PropTypes.string),
  fillOnSurface: PropTypes.string,
  fillSurface: PropTypes.string,
  bottomBarFill: PropTypes.string,
  primary: PropTypes.string,
  name: PropTypes.string,
};

export default RightScreen;
